export const DEFAULT_ARCHIREPO_EXTERNAL_IDENT = "archirepo";

export interface TrackerConfigDto {
    trackerEnabled: boolean;
    baseUrl?: string;
    taskUrl?: string;
    clientRegistrationId?: string;
    archirepoExternalIdent?: string;
}
